import ItemName from "NstyleComponents/dist/components/Text/ItemName";
import React from "react";
import PropTypes from 'prop-types';
import {assignmentsColumns, sortDirection} from "./AssignmentsConstants";
import {setAssignmentSortingOptions} from "../../../../actions/assignments/assignmentsAction";
import {AssignmentSortModel} from "../../../../models/assignments/AssignmentModel";
import {SortableColumnHeader} from "./SortableColumnHeader";
import { useDispatch } from "react-redux";

export const AssignmentsTableHeader = ({sortOptions}) => {
    const dispatch = useDispatch();

    const sort = columnName => {
        const newSortOptions = {
            columnName: columnName,
            direction: calculateDirection(columnName)
        };

        dispatch(setAssignmentSortingOptions(newSortOptions));
    };

    const calculateDirection = columnName => {
        if (columnName === sortOptions.columnName)
            return (sortOptions.direction === sortDirection.descending) ? sortDirection.ascending : sortDirection.descending;

        return sortDirection.ascending;
    };

    return <div className="assignments__header">
        <div className="columns is-vcentered is-marginless is-paddingless">
            <SortableColumnHeader columnDisplayName="All Assignments"
                                  columnName={assignmentsColumns.name}
                                  onSort={sort}
                                  sortOptions={sortOptions}
                                  className="is-4-widescreen is-4-touch" />
            <SortableColumnHeader columnDisplayName="Product"
                                  columnName={assignmentsColumns.productName}
                                  onSort={sort}
                                  sortOptions={sortOptions}
                                  className="is-2-widescreen is-2-touch"/>
            <SortableColumnHeader columnDisplayName="Status"
                                  columnName={assignmentsColumns.status}
                                  onSort={sort}
                                  sortOptions={sortOptions}
                                  className="is-2-widescreen is-2-touch"/>
            <SortableColumnHeader columnDisplayName="Start Date"
                                  columnName={assignmentsColumns.startDate}
                                  onSort={sort}
                                  sortOptions={sortOptions}
                                  className="is-2-widescreen is-2-touch"/>
            <SortableColumnHeader columnDisplayName="Due Date"
                                  columnName={assignmentsColumns.dueDate}
                                  onSort={sort}
                                  sortOptions={sortOptions}
                                  className="is-2-widescreen is-2-touch"/>                                  
        </div>
    </div>;
};

AssignmentsTableHeader.propTypes = {
    sortOptions: PropTypes.shape(AssignmentSortModel)
};

export default AssignmentsTableHeader;
